import { copyToClipboard } from '@mi-front/core';
import { notifyInfo } from '@ui/notifications';
import moment from 'moment-timezone';
import { useCallback } from 'react';
import { defineMessage, useIntl } from 'react-intl';
import { buildLoggerStreamUrl } from './build-logger-stream-url';
import { Station } from '@app/core/types/stations';

const copyCursorLinkCopiedMessage = defineMessage({
  id: 'logger.streamScreen.copyCursorLinkCopied',
  defaultMessage: 'Link copiado al portapapeles',
});

/**
 * Hook that returns a function to copy the cursor URL to clipboard.
 * Builds a direct logger URL with cursor timestamp for audit context.
 */
export function useCopyCursorToClipboard(): (station: Station, ts: number) => void {
  const { $t } = useIntl();

  return useCallback(
    (station: Station, ts: number) => {
      const url = buildLoggerStreamUrl(
        station.slug,
        {
          cursor: moment(ts).valueOf(),
        },
        { absolute: true },
      );

      copyToClipboard(url);

      notifyInfo($t(copyCursorLinkCopiedMessage));
    },
    [$t],
  );
}
